<template>
	<div class="header">
		<a class="header__left" href="/">
			<svg width="40" height="40">
				<use xlink:href="sprite.svg#logo"></use>
			</svg>
			<div class="header__left-text">Электронная похозяйственная книга</div>
		</a>
	</div>
</template>

<script setup></script>

<style lang="scss">
@import './EpkHeader.scss';
</style>
